<template lang="pug">
    section.age-gate
        div.hero.is-fullheight
            div.hero-body
                div.container.has-text-white.has-text-centered
                    div.columns.is-centered
                        div.column
                            div.has-text-centered
                                ul.age-gate-lang
                                    li.age-gate-lang-locale.is-pointer.is-size-13(
                                        v-for="locale in locales",
                                        :key="locale.code",
                                        @click="$i18n.locale = locale.code",
                                        :class="{ 'has-text-weight-bold': locale.code === $i18n.locale }"
                                    ) {{ locale.name }}

                    div.columns.is-centered
                        div.column.is-2
                            img.age-gate-logo(src="../assets/images/1_Landing/Logo_CR_landing.svg", alt="casa-relvas-logo")
                    h1.is-uppercase.is-size-25 {{ $t('age_gate.title') }}
                    div.columns.is-centered
                        div.column.is-6
                            p.has-text-weight-light {{ $t('age_gate.text') }}
                    div.columns.is-centered.is-2.is-mobile
                        div.column.is-2-desktop
                            button.button.is-small.is-white.is-outlined(@click="submit") {{ $t('age_gate.button_1') }}
                        div.column.is-2-desktop
                            button.button.is-small.is-white.is-outlined(@click="underage = true") {{ $t('age_gate.button_2') }}
                    div.columns(v-if="underage")
                        div.column.has-text-centered
                            p {{ $t('age_gate.underage') }}
                    div.columns.is-centered.is-vcentered.is-variable.is-2.is-mobile(v-else)
                        div.column.is-narrow
                            img.is-checkmark(
                                src="../assets/images/1_Landing/Check_hover.svg",
                                @click="checkmarkOn = !checkmarkOn"
                                @mouseout="checkmarkHover = false",
                                v-if="checkmarkOn || checkmarkHover"
                            )
                            img.is-checkmark(src="../assets/images/1_Landing/Check_normal.svg",
                                @mouseover="checkmarkHover = true",
                                v-else)
                        div.column.is-narrow
                            p.has-text-weight-light(for="drink") {{ $t('age_gate.cookie') }}
                    h2.is-size-7.has-text-weight-light.is-uppercase.has-letter-spacing-200 {{ $t('age_gate.notice') }}

</template>

<script>
export default {
    name: 'age-gate',
    data () {
        return {
            remember: false,
            checkmarkHover: false,
            checkmarkOn: false,
            locales: [
                {
                    code: 'pt',
                    name: 'PT'
                },
                {
                    code: 'en',
                    name: 'EN'
                }
            ],
            underage: false
        }
    },
    methods: {
        submit () {
            if (!this.underage) {
                sessionStorage.setItem('drinkable', true)
                this.$router.push('/')
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.age-gate
    position fixed
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 100
    background url("../assets/images/1_Landing/banner_landing.jpg") no-repeat fixed center

    @media screen and (max-width 768px)
        background url("../assets/images/1_Landing/Intro_banners-banners.jpg") no-repeat fixed center

    &-logo
        @media screen and (max-width 1024px)
            width 35vw

    .container > *
        margin-bottom 1.5rem

        &:last-child
            margin-top 3.125rem
            margin-bottom 0

    .button
        width 100%

    &-lang-locale
        display inline-block

        & + &:before
            content '|'
            margin 0 10px

.is-checkmark
    cursor pointer
    width 3rem
</style>
